import { FeatureSection } from "./components/sections/FeatureSection";
import { Footer } from "./footer/NewFooter";
import { Hero } from "./payor_network/components/Hero";
import { ProblemSection } from "./payor_network/components/ProblemSection";
import ProviderNavigation from "../ProviderNavigation";
import { StatsSection } from "./components/sections/StatsSection";
import { WhyVerseSection } from "./payor_network/components/WhyVerseSection";
import { getFeatureSections } from "./payor_network/config/payorNetworkConfig";

export default function PayorNetworkPage() {
  const featureSections = getFeatureSections();

  return (
    <div className="tw-relative tw-min-h-screen tw-overflow-x-hidden">
      <div className="tw-bg-[url('/landing_page_assets/backgrounds/bg5.png')] tw-bg-cover tw-bg-right-bottom">
        <ProviderNavigation isDark />
        <div className="tw-relative tw-mx-auto tw-mt-[48px] tw-max-w-[1448px] tw-px-[20px]">
          <div className="tw-flex tw-h-full tw-flex-col tw-gap-y-[64px]">
            <Hero />
            <StatsSection
              className="tw-pb-[4em] min440:tw-grid-cols-4"
              stats={[
                {
                  value: "1",
                  description: "full-risk contract",
                  disableAnimation: true,
                },
                { value: "10-20%", description: "lower DME spend" },
                {
                  value: "99.9%",
                  description: "order accuracy",
                },
                { value: "73", description: "patient NPS" },
              ]}
            />
          </div>
        </div>
      </div>
      <ProblemSection />
      <WhyVerseSection />
      <div className="tw-relative tw-mx-auto tw-flex tw-h-full tw-max-w-[1448px] tw-flex-col tw-gap-y-[80px] tw-overflow-hidden tw-px-[24px] tw-py-[56px] min440:tw-gap-y-[120px] min440:tw-px-[76px]">
        {featureSections.map((section, index) => (
          <FeatureSection
            key={`feature-section-${index}`}
            {...section}
            className={section.className}
          />
        ))}
      </div>
      <Footer
        title="Partner with"
        titleAccent="Verse"
        description="Your partner in DME cost reduction and care delivery."
        isRounded
        hasSquiggle
        buttonText="Connect with our team"
        buttonClassName="tw-w-[15em]"
      />
    </div>
  );
}
